<template>
  <div>
    <input type="file" @change="upload" accept="video/mp4">
    <div>{{this.img_oss + file_name}}</div>
  </div>
</template>

<script>
import { PostData } from '@/api/fetchdata'
import { getStorage } from '@/service/auth.js'
export default {
  data() {
    return {
      file_token: '',
      upload_id: '',
      file_name: '',
    };
  },
  methods: {
    getUploadId(file_type) {
      return PostData({
        service: 'App.Oss.GetUploadId',
        uid: getStorage('uid'),
        token: getStorage('token'),
        file_type,
      }).then(res => {
        if (res.data.ret == 200) {
          this.file_token = res.data.data.file_token;
          this.upload_id = res.data.data.upload_id;
        } else {
          throw new Error(res.data.msg);
        }
      })
    },
    multiUploadFiles(file, file_name, index, total) {
      let form = new FormData();
      form.append('service', 'App.Oss.MultiUploadFiles');
      form.append('uid', getStorage('uid'));
      form.append('token', getStorage('token'));
      form.append('upload_id', this.upload_id);
      form.append('file_token', this.file_token);
      form.append('file', file, file_name);
      form.append('chunk', index);
      form.append('chunks', total);
      return this.$http.post(this.$proxyurl, form).then(res => {
        if (res.data.ret !== 200) {
          throw new Error(res.data.msg)
        }
      })
    },
    completeUpload(file_name) {
      return PostData({
        service: 'App.Oss.CompleteUpload',
        uid: getStorage('uid'),
        token: getStorage('token'),
        upload_id: this.upload_id,
        file_name,
      }).then(res => {
        if (res.data.ret == 200) {
          this.file_name = file_name;
          this.file_token = '';
          this.upload_id = '';
        } else {
          throw new Error(res.data.msg)
        }
      })
    },
    upload() {
      let file = event.target.files[0];
      let file_type = file.name.split('.').pop() || '';
      this.getUploadId(file_type).then(() => {
        let file_name = this.file_token + '.' + file_type;
        let file_size = file.size;
        let totalPieces = Math.ceil(file_size / (1024 * 1024)); // //计算文件切片总数, 每个文件切片大小定为1MB
        // 开始切片
        let start = 0;
        let end = 0;
        let index = 0;
        let chunks = [];
        while (index < totalPieces) {
          end = start + 1024 * 1024;
          if (end > file_size) {
            end = file_size;
          }
          chunks.push(this.multiUploadFiles(file.slice(start, end), file_name, index, totalPieces));
          start = end;
          index = index + 1;
        }
        Promise.all(chunks).then(() => {
          this.completeUpload(file_name);
        }).catch(error => {
          this.$message({type: 'warning', message: error.message});
        });
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue